import {useAnalytics} from '@github-ui/use-analytics'
import {Button, Label} from '@primer/react'
import {type RefObject, useCallback, useMemo, useRef} from 'react'

import type {SuggestedChange} from '../../../conversation-types'

export function CommitOrRemoveFromBatch({
  onOpenDialog,
}: {
  onOpenDialog: (returnFocusRef?: RefObject<HTMLElement>) => void
}) {
  const returnFocusRef = useRef<HTMLButtonElement>(null)
  const handleCommitBatchClick = useCallback(() => {
    onOpenDialog(returnFocusRef)
  }, [onOpenDialog])

  // TODO: We don't currently handle batching suggested changes in Files Changed experience. When we do, this line should likely be stored in a Zustand slice.
  const pendingSuggestedChangesBatch: SuggestedChange[] = useMemo(() => [], [])
  const batchCount = pendingSuggestedChangesBatch.length
  const {sendAnalyticsEvent} = useAnalytics()

  const handleRemoveFromBatchClick = useCallback(() => {
    // TODO: Implement when we add suggested changes batching
    // removeSuggestedChangeFromPendingBatch(suggestedChange)
    sendAnalyticsEvent('comments.remove_suggested_change_from_batch', 'REMOVE_SUGGESTED_CHANGE_FROM_BATCH_BUTTON')
  }, [sendAnalyticsEvent])

  return (
    <div className="d-flex flex-row flex-justify-between">
      <Label variant="attention" className="my-auto">
        Pending in batch
      </Label>
      <div className="d-flex gap-2">
        <Button size="medium" variant="danger" onClick={handleRemoveFromBatchClick}>
          Remove from batch
        </Button>
        <Button
          ref={returnFocusRef}
          size="medium"
          count={batchCount}
          variant="primary"
          onClick={handleCommitBatchClick}
        >
          {`Apply suggestion${batchCount > 1 ? 's' : ''}`}
        </Button>
      </div>
    </div>
  )
}

try{ CommitOrRemoveFromBatch.displayName ||= 'CommitOrRemoveFromBatch' } catch {}